import { Component, OnInit } from '@angular/core';
import { SessionStateService } from '../../../core/services/session-state.service';
import { House } from '../../houses/houses.model';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material';
import { EditAddressDialogComponent } from '../edit-address-dialog/edit-address-dialog.component';
import { HousesService } from '../../houses/houses.service';
import { ProfileUtils } from '../profile.model';

@Component({
  selector: 'app-profile-house',
  templateUrl: './profile-house.component.html',
  styleUrls: ['./profile-house.component.scss']
})
export class ProfileHouseComponent implements OnInit {
  AdressDialogRef: MatDialogRef<EditAddressDialogComponent>;
  loading = true;

  house: House;
  ProfileUtils = ProfileUtils;
  constructor(private sessionStateService: SessionStateService,
    private dialog: MatDialog,
    private housesService: HousesService,
    private router: Router) { }

  ngOnInit() {
    this.loadHouse();
  }

  loadHouse() {
    if (this.sessionStateService.getHouse()) {
      this.house = this.sessionStateService.getHouse();
    }
  }

  getHouseName() {
    if (this.house) {
      return this.house.name;
    }
  }

  getAddress() {
    if (this.house) {
      return this.house.address;
    }
  }

  editAddress() {
    let myHouse;
    const houseId = this.sessionStateService.getHouse().houseId;
    this.housesService.getHouses().subscribe(houses => {
      houses.forEach(house => {
        if (house.houseId === houseId) {
          myHouse = house;
          this.AdressDialogRef = this.dialog.open(EditAddressDialogComponent, {
            data: {
              name: myHouse.name,
              district: myHouse.district,
              address: myHouse.address,
              city: myHouse.city,
              postal: myHouse.postalCode,
            },
            autoFocus: false,
            panelClass: 'editAddressPopup'
          });
          const sub = this.AdressDialogRef.componentInstance.action
            .subscribe((response: boolean) => {
              if (response) {
                this.updateHouse();
              }
              this.AdressDialogRef.close();
            });
        }
      });
    });
  }

  updateHouse() {
    const houseId = this.sessionStateService.getHouse().houseId;
    this.housesService.getHouses().subscribe(houses => {
      houses.forEach(house => {
        if (house.houseId === houseId) {
          this.house = house;
          this.sessionStateService.setHouse(this.house);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/profile/profile-house/profile-house.component.ts